export default __webpack_public_path__ + "static/media/profile-icon.abd254c8.svg";